export default "__VITE_ASSET__Du3Kb7iJ__"